<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn color="error"
             :loading="loading"
             v-on="on">
        Recusar
      </v-btn>
    </template>
    <v-list>
      <template v-for="(option, index) in options">
        <v-list-item
          :key="index"
          @click="onClickItem(option)"
          v-if="option.key !== KEY_OUTRA"
        >
          <v-list-item-title>{{ option.description }}</v-list-item-title>
        </v-list-item>
        <px-recusar-cotacao-motivo v-model="dialog"
                                   v-if="option.key === KEY_OUTRA"
                                   @change="onChangeMotivo"
                                   :key="index">
          <template v-slot:activator="{ on }">
            <v-list-item
              :key="index"
              v-on="on"
            >
              <v-list-item-title>{{ option.description }}</v-list-item-title>
            </v-list-item>
          </template>
        </px-recusar-cotacao-motivo>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import { SituacaoSolicitacaoFrete } from 'px-business-components';
import RecusarCotacao from './recusar-cotacao';

export default {
  props: {
    loading: Boolean,
  },
  data() {
    return {
      dialog: false,
      options: RecusarCotacao.values,
      KEY_OUTRA: SituacaoSolicitacaoFrete.keys.OUTRA.key,
    };
  },
  methods: {
    onChangeMotivo(motivo) {
      const option = { ...SituacaoSolicitacaoFrete.keys.OUTRA, motivo };
      this.$emit('change', option);
    },
    onClickItem(option) {
      if (option.key === SituacaoSolicitacaoFrete.keys.OUTRA.key) {
        this.dialog = true;
        return;
      }
      this.$emit('change', option);
    },
  },
};
</script>
